<script>
import BookmakerStackerTile from './BookmakerStackerTile.vue';
import { mapGetters } from 'vuex';
export default {
  name: 'BookmakerStacker',
  components: {
    BookmakerStackerTile,
  },
  props: {
    brand: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      bookmakers: 'BookmakerStacker/getBookmakersForStacker',
    }),
    moreOffersURL() {
      return this.brand === 'punters' ? '/betting/bonus-bets/' : '/bonus-bets';
    },
    termsAndConditions() {
      const { bookmakers } = this;
      if (bookmakers.length > 0) {
        return bookmakers[0].termAndCondition;
      }
      return '';
    },
    recommendedBookmaker() {
      const { bookmakers } = this;
      return bookmakers.length > 0 ? bookmakers[0] : {};
    },
  },
  created() {
    this.$store.dispatch('BookmakerStacker/fetchBookmakersForStacker', this.brand);
  },
};
</script>

<template>
  <div class="bookie-stacker">
    <div :class="`bookie-stacker__header header--${brand}`">Top Bookmakers</div>
    <div class="bookie-stacker__tiles">
      <template v-for="(tile, index) in bookmakers">
        <BookmakerStackerTile
          :key="index"
          :brand="brand"
          :pos="tile.position"
          :bookmaker="tile.permalink"
          :bookmaker-info="tile.description"
          :bookmaker-link="tile.claimUrl"
          :primary-color="tile.primaryColor"
        />
      </template>
    </div>

    <div :class="`bookie-stacker__terms`">
      <p v-html="termsAndConditions"></p>
    </div>
  </div>
</template>
